import { AppSidebar } from '@/components/ui/app-sidebar';
import NavigationBreadCrumb from '@/components/ui/custom/navigation-breadcrumbs';
import { SidebarProvider, useSidebar } from '@/components/ui/sidebar';
import { getAccessToken } from '@/lib/client';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export const Route = createFileRoute('/dashboard')({
  beforeLoad: async () => {
    const token = getAccessToken();
    const refreshToken =
      globalThis.window?.localStorage.getItem('jumbo-refresh') || null;

    if (!token && (!refreshToken || refreshToken.trim() === '')) {
      throw redirect({ to: '/login' });
    }
  },
  component: DashboardLayout,
});

function DashboardContent({ children }: { children: ReactNode }) {
  const { open, isMobile } = useSidebar();

  return (
    <div className='h-screen w-full overflow-hidden'>
      <AppSidebar />
      <div
        className={`flex flex-col h-full transition-all duration-500 ease-in-out ${
          open
            ? isMobile
              ? 'min-w-[100vw]'
              : 'pl-[14rem] w-[100vw]'
            : 'w-[100vw]'
        }`}
      >
        <div className='flex-shrink-0'>
          <NavigationBreadCrumb />
        </div>
        <main className='flex-1 overflow-y-auto relative z-10'>{children}</main>
      </div>
    </div>
  );
}

function DashboardLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <DashboardContent>
        <Outlet />
      </DashboardContent>
    </SidebarProvider>
  );
}
